import {
    Box,
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Typography
} from "@mui/material";
import SortIcon from '@mui/icons-material/Sort';
import { enqueueSnackbar } from "notistack";
import * as XLSX from 'xlsx';
import { FileDownload } from "@mui/icons-material";
import { useState } from "react";
import { User } from "../../types/User";
interface UserCountAndSortSectionProps {
    users: User[];
    usersCount: number;
    sortOrder: string;
    setSortOrder: (order: string) => void;
    sortBy: string;
    setSortBy: (by: string) => void;
}

export const UserCountAndSortSection = ({
    users,
    usersCount,
}: UserCountAndSortSectionProps) => {
    const [loading, setLoading] = useState(false);

    const exportToExcel = () => {
        try {
            // Create a new workbook
            setLoading(true);
            const workbook = XLSX.utils.book_new();

            // Prepare data for export by selecting relevant fields
            const exportData = users.map(user => ({
                'Full Name': user.fullName || '-',
                'Email': user.email || '-',
                'Role': user.role || '-',
                'Gender': user.gender || '-',
                'Location': user.location || '-',
                'Phone': user.phone || '-',
                'Age': user.birthDate ? new Date().getFullYear() - new Date(user.birthDate).getFullYear() : '-',
                'Description': user.description || '-',
                'Job Title': user.jobTitle || '-',
                'Job Description': user.jobDescription || '-',
                'Job Looking For': user.jobLookingFor || '-',
                'Job Looking For Location': user.jobLookingForLocation || '-',
                'Job Looking For Salary': user.jobLookingForSalary || '-',
                'Job Looking For Type': user.jobLookingForType || '-',
                'Skills': user.skills || '-',
                'Education': user.education || '-',
                'Work History': user.workHistory || '-',
            }));

            // Convert data to worksheet
            const worksheet = XLSX.utils.json_to_sheet(exportData);

            // Add worksheet to workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Users');

            // Generate and download Excel file
            XLSX.writeFile(workbook, 'users_list.xlsx');

            enqueueSnackbar('Users exported successfully', { variant: 'success' });
        } catch (error) {
            console.error('Export error:', error);
            enqueueSnackbar('Failed to export users', { variant: 'error' });
        }
    };


    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="subtitle1">
                {usersCount} users
            </Typography>
            <Button
                variant="contained"
                startIcon={<FileDownload />}
                onClick={exportToExcel}
                disabled={loading || users.length === 0}
            >
                Export to Excel
            </Button>
        </Box>
    )
}